import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_order",
  "use": "icon-home_order-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol viewBox=\"0 0 20 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home_order\">\n<path d=\"M3.58594 0L1.58594 2H0V4H2.41406L5 1.41406L3.58594 0ZM7 2V4H20V2H7ZM7 8V10H20V8H7ZM7 14V16H20V14H7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol